import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Item, Message, Image, Container, Divider, Loader, Search, Dropdown, Pagination, Menu, Table, Button, Icon } from 'semantic-ui-react'
import smoothscroll from 'smoothscroll-polyfill'
import { backendService } from '../../services/backendService'
import _ from 'lodash'
import Logo from '../../images/logo-admin.png'
import moment from 'moment';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { history } from '../../store'

const queryTypeEnumValues = {
  'type_verdict': 1,
  'type_principle': 0
} 

class QueryHistory extends React.Component {

  constructor() {
    super()
    this.sortQuestions = this.sortQuestions.bind(this)
    this.getQuestions = this.getQuestions.bind(this)
    this.state = {
      questions: [],
      error: false,
      descendingOrder: false,
      searchedElements: [],
      loading: false,
      period: 'all time',
      historyFilter: '',
      historySortIndex: 1,
      historySort: 'DESC',
      historySortDateDirection: 'descending',      
      historyLimit: 10,
      historyFrom: '',
      historyTo: '',
      historyCount: 0,
      activePage: 1
    }   

  }
  

  componentDidMount() {

    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'History'
      }
    });

    this.getQuestionCount()
    this.getQuestions()
  }

  hideMessage() {
    const self = this
    setTimeout(function () {
      self.setState({ error: false })
    }, 3000)
  }

  sortQuestions(sortType) {
    const currentSort = this.state.historySort
    if (sortType !== currentSort) {
      this.setState({historySort: sortType}, () => {
        this.getQuestions()
      })
    }
  }

  toggleDateSortQuestion() {
    const sorts = [ 'ASC', 'DESC'];
    const sortsNames = [ 'ascending', 'descending'];
    const currentSort = (this.state.historySortIndex + 1 ) % 2;
    this.setState({historySortIndex: currentSort, historySort: sorts[currentSort], historySortDateDirection: sortsNames[currentSort]}, () => {
      this.getQuestions()
    })    
  }


  async getQuestionCount() {
    this.setState({ historyCount: 0})
    try {      
      const response = await backendService.get(`/api/questions/count`, 
                                                  { params: {user: this.props.auth.user.email,
                                                    filter: this.state.historyFilter,                                                    
                                                    from : this.state.historyFrom,
                                                    to: this.state.historyTo  }                                                 
                                                  });

      if (response.data) {
        const maxPageCount = Math.ceil(response.data.count / this.state.historyLimit)
        if (this.state.activePage > maxPageCount) {
          await this.setState({activePage: maxPageCount})
        }
        await this.setState({ historyCount: maxPageCount})
      } else {
        this.setState({ error: Translate(this.context, 'generic_fail_message') })
        this.hideMessage()
      }
      this.setState({ loading: false })
    } catch (exc) {
      this.setState({ loading: false })
    }
  }

  async getQuestions() {
    this.setState({ questions: [], searchedElements: [] })
    this.setState({ loading: true })
    try {
      const historyOffset = (this.state.activePage - 1) * this.state.historyLimit
      const response = await backendService.get(`/api/questions`, 
                                                  { params: {
                                                    user: this.props.auth.user.email,
                                                    offset: historyOffset, 
                                                    limit: this.state.historyLimit, 
                                                    filter: this.state.historyFilter, 
                                                    sort: this.state.historySort,
                                                    from : this.state.historyFrom,
                                                    to: this.state.historyTo }
                                                  });

      if (response.data) {
        this.setState({ questions: response.data, searchedElements: response.data })
      } else {
        this.setState({ error: Translate(this.context, 'generic_fail_message') })
        this.hideMessage()
      }
      this.setState({ loading: false })
    } catch (exc) {
      this.setState({ loading: false })
    }
  }

  handleSearchChange = (e, { value }) => {   
    if (this.state.debouncedFunc)
      this.state.debouncedFunc.cancel()
    const debounceFunc =  _.debounce(this.searchHistory.bind(this), 1000, { leading: false });
    debounceFunc();
    this.setState({ historyFilter: value, debouncedFunc: debounceFunc})    
  }

  async searchHistory() {
    await this.getQuestionCount()
    this.getQuestions()
  }

  async handleChangePeriod(e, data) {

    this.setState({period: data.value})

    let from = ''
    if (data.value === 'last month') {
      from = moment().subtract(1, 'months').format('YYYY-MM-DD');
    }
    else if(data.value === 'last 7 days') {
      from = moment().subtract(7, 'days').format('YYYY-MM-DD');
    }
    else {
      from = ''
    }
    this.setState({ questions: [], searchedElements: [],  historyFrom: from}, async () => {
      this.searchHistory()
    })
  }

  handleChangeLimit = (e, data) => { 
    this.setState({historyLimit: data.value}, () => {this.searchHistory()})
  }

  handleChangePage = (e, data) => {
    this.setState({activePage: data.activePage}, () => {this.getQuestions()})
  }


  handleItemClicked(e) {
    e.preventDefault()
    const query = e.target.dataset.query
    if (query) {
      history.push({
        pathname: '/',
        state: { queryToReSearch: query }
      })
      history.go(0)
    }
  }

  render() {
    const isLoading = this.state.loading
    const historyFilter = this.state.historyFilter

    const options = [
      { key: 1, text: Translate(this.context, 'history_last_7_days'), value: 'last 7 days' },
      { key: 2, text: Translate(this.context, 'history_last_month'), value: 'last month' },
      { key: 3, text: Translate(this.context, 'history_all_time'), value: 'all time' },
    ]

    const paginationOptions = [
        { key: 0, text: '10', value: 10 },
        { key: 1, text: '25', value: 25 },
        { key: 2, text: '50', value: 50 },
        { key: 3, text: '100', value: 100 },
      ]
    
    return (
      <>
      <Row>        
        <Col xs={8} sm={4} md={3} className='lisia-app-logo-wrapper'>
          <Link to='/'>
            <Image src={ Logo } />
          </Link>
        </Col>        
        <Col className="lisia-app-card-content centered history" xs={12} md={10}>  
          <div className='lisia-app-header'>
            <div className='header'>
              <Link to='/'>
                <Text tid="back" />
              </Link>            
            </div>          
            <h3 className='text-center lisia-app-card-title'><Text tid="history_title" /></h3>
          </div>
          <Divider />
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <Search
                className='searchHistory'
                loading={isLoading}
                value={historyFilter}
                showNoResults={false}
                placeholder={Translate(this.context, 'history_search_placeholder')}
                onSearchChange={this.handleSearchChange}
              />
              <Dropdown
                fluid
                style={{width: '15%', minWidth: '100px'}}
                value={this.state.period}
                selection
                options={options}
                onChange={this.handleChangePeriod.bind(this)}
              />
          </div>            
          <br/>          
          {this.state.loading &&
            <Loader active inline='centered' className='marginLoadMore' />
          }
          {this.state.searchedElements.length > 0 &&
            <div className="col-xs-12 col-md-12" 
                 style={{ maxHeight: '550px', overflow: 'auto'}}                 
            >
              <Table sortable unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className='lisia-history-query-search-again'></Table.HeaderCell>                    
                    <Table.HeaderCell className='lisia-history-date'
                      sorted={this.state.historySortDateDirection}
                      onClick={() => this.toggleDateSortQuestion()}
                    >
                      <Text tid="history_date" />
                    </Table.HeaderCell>
                    <Table.HeaderCell className='lisia-history-query-type'><Text tid="history_query_type" /></Table.HeaderCell>
                    <Table.HeaderCell className='lisia-history-query' ><Text tid="history_query" /></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  { this.state.searchedElements.map((question, i) => {
                     return (
                      <Table.Row className='lisia-history-row'>
                        <Table.Cell className='lisia-history-query-search-again'>                            
                            <Link to={{ pathname: '/', state: { queryToReSearch: question.query, selectedType: queryTypeEnumValues[question.query_type.toLowerCase()] } }}>
                              <Icon size='big' className='lisia-blue-search-icon' name='search' />                              
                            </Link>
                        </Table.Cell>  
                        <Table.Cell className='lisia-history-date'>{(new Date(question.createdAt)).toLocaleDateString("it-IT")}</Table.Cell>
                        <Table.Cell className='lisia-history-query-type'>{Translate(this.context, question.query_type.toLowerCase())}</Table.Cell>

                        <Table.Cell className='lisia-history-query'>{question.query}</Table.Cell>                    
                      </Table.Row>
                      )
                    })
                }                  
                </Table.Body>
              </Table>  
            </div>
          }
        </Col>
      </Row>
      {this.state.historyCount > 0 && 
      <Row>
        <Col  className="centered history lisia-pagination" xs={12} md={10}>
          <Menu compact>
            <Dropdown
              value={this.state.historyLimit}
              fluid
              selection
              options={paginationOptions}
              onChange={this.handleChangeLimit}
            />
          </Menu>
          <Pagination 
            defaultActivePage={this.state.activePage} 
            totalPages={this.state.historyCount} 
            onPageChange={this.handleChangePage}
            //prevItem={null}
            //nextItem={null}
            firstItem={null}
            lastItem={null}
            siblingRange={0}
            boundaryRange={1}
            ellipsisItem={null}
          />
        </Col>
      </Row>}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

QueryHistory.contextType = LanguageContext;

export default connect(mapStateToProps)(QueryHistory)